package showdown.web.ui

class Strings {
    companion object {
        const val anonym: String = "anonymize vote results"
        const val CONNECTION_ERROR = "You are not connected to the server"
        const val CONNECTION_LOST = "Connection lost"
        const val IM_SPECTATOR = "I'm a spectator"
        const val INSERT_NAME: String = "Insert a name"
        const val JOIN_GAME = "Join Game"
        const val NO_CONNECTION = "No Connection"
        const val PW_REQUIRED = "A room password is required"
        const val RESULT = "Result:"
        const val SHOWDOWN = "Showdown"
        const val SHOWDOWN_REPO_URL = "https://github.com/Foso/Showdown"
        const val SHOWDOWN_ISSUES_URL = "$SHOWDOWN_REPO_URL/issues"
        const val SHOWDOWN_VERSION = "1.3.3"
        const val TOP_VOTED_ANSWER: String = "Top Voted Answer:"
        const val VOTED = "Voted:"
        const val WAITING_FOR = "Waiting for:"


        /**
         * OPTIONS
         */
        const val SELECT_OPTION: String = "Select an option"
        const val RANDOM_BUTTON_TOOLTIP = "Select a random option"

        /**
         * SETTINGS
         */
        const val SETTINGS_ABOUT = "About"
        const val AUTO_REVEAL = "Auto Reveal votes when all voted"
        const val CHANGE_MODE = "Change Mode"
        const val GAME_MODE = "GameMode"
        const val GAME_SETTINGS = "Game Settings"
        const val REMOVE_PASSWORD: String = "Remove PASSWORD"
        const val ROOM_PASSWORD_SETTINGS = "Room Password Settings"
        const val Save_PASSWORD: String = "Save PASSWORD"
        const val SET_ROOM_PW = "Set a new room password:"
        const val SETTINGS_GAMEMODE = "Insert Custom options separate with semicolon (;)"


        /**
         * TOOLBAR
         */
        const val NEW_VOTING: String = "New Voting"
        const val SHOW_VOTES = "Show Votes"
        const val SETTINGS = "Settings"


    }

}